import styles from "./styles/mastering-reference-tab.module.scss";
import UploadDragAndDrop from "@/components/common/upload-drag-and-drop";
import { audio } from "@/data/extensions";
import { useAiMastering } from "@/components/pages/ai-mastering/providers/ai-mastering-provider";
import MasteringPlayer from "@/components/pages/ai-mastering/components/mastering-player";
import React from "react";
import deleteIcon from "@/assets/icons/delete-icon.svg";
import { validateMusicFile } from "@/components/pages/ai-mastering/providers/mastering";
import useMasteringModal from "@/components/pages/ai-mastering/hooks/use-mastering-modal";

const MasteringReferenceTab = () => {
  const { setReferenceTrack, referenceTrack, currentOptionTab } =
    useAiMastering();
  const { showErrorModal } = useMasteringModal();

  if (currentOptionTab !== "referenceTrack") {
    return <></>;
  }

  if (referenceTrack) {
    return (
      <MasteringPlayer
        trackUrl={URL.createObjectURL(referenceTrack)}
        titles={[referenceTrack.name]}
        onAction={() => setReferenceTrack(undefined)}
        actionIcon={deleteIcon}
      />
    );
  }

  return (
    <UploadDragAndDrop
      handleFilesAdded={async (files) => {
        const file = files[0];
        const error = await validateMusicFile(file);
        if (error) {
          showErrorModal("Uploading file error!", error);
          return;
        }

        setReferenceTrack(file);
      }}
      acceptedFiles={audio}
      topText={`Add Reference Track for Mastering`}
      bottomText="Max file size: 200 MB, Max file duration: 12 minutes"
      isActive={true}
      isMultiple={false}
    />
  );
};

export default MasteringReferenceTab;
